module.exports = __webpack_public_path__ + "media/meditation-full.6852b35a.webm";